<template>
    <div id="app">
        <home-eight/>
    </div>
</template>


<script>
// import HomeSix from '../components/HomeSix/index'
import HomeEight from '../components/HomeEight/index'
export default {
	components: {HomeEight  },

}
</script>



<style>

</style>
